import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ProjectCard } from '../Models/ProjectCard';
// saveCard, 
import { getProject, setCards } from '../Store/Project';
import { useAppDispatch, useAppSelector } from '../Core/hooks';
import { openSocket } from '../Helpers/openSocket';

/* Quill imports are required because nested lists in editor use classes, not
   true semmantic nested lists. To get them to display correctly in view mode, 
   we must import these and apply the same class Quill does in editor mode.
   https://github.com/quilljs/quill/issues/1314
*/
import 'react-quill/dist/quill.core.css';
import 'react-quill/dist/quill.bubble.css';
import 'react-quill/dist/quill.snow.css';
import { getSettings } from '../Store/Settings';

interface Props {
    card: ProjectCard;
    closeHandler: (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>, visible: boolean) => void;
    editing: boolean;
}

function CardEditor(props: Props) {
    const projectState = useAppSelector(getProject);
    const settingsState = useAppSelector(getSettings);
    const editorRef = useRef<ReactQuill | null>(null);

    const dispatch = useAppDispatch();
    const [description, setDescription] = useState('');

    useEffect(() => {
        setDescription((props.card.description));
    }, []);

    useEffect(() => {
        setDescription(props.card.description);
      }, [props.card.description]);

    useEffect(() => {
        if (props.editing && editorRef && editorRef.current && editorRef.current.editor) {
            let descriptionLength = editorRef.current.editor.getLength();
            editorRef.current.editor.setSelection(descriptionLength +1,1);
        }
    }, [props.editing])

    useEffect(() => {    
        const interval = setInterval(() => {
            if (editorRef.current?.getEditor?.()) {
                // @ts-ignore
                editorRef.current
                .getEditor()
                .getModule('toolbar')
                .addHandler('image', () => {

                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');
                input.click();

                input.onchange = () => {
                    const file = input.files?.[0];
                    if (!file) return;

                    const reader = new FileReader();
                    reader.onload = () => {
                    const base64Image = reader.result as string;
                    const quill = editorRef.current?.getEditor();
                    if (!quill || !base64Image) return;

                    // Delay insertion to ensure Quill is fully ready
                    setTimeout(() => {
                        const range = quill.getSelection(true) || { index: quill.getLength() };
                        try {
                        quill.insertEmbed(range.index, 'image', base64Image, 'user');
                        quill.setSelection(range.index + 1);
                        } catch (err) {
                        console.error('Quill insertEmbed failed:', err);
                        }
                    }, 0);
                    };
                    reader.readAsDataURL(file);
                }
                })
                clearInterval(interval);
            }
        }, 100);
        return () => clearInterval(interval);
      }, [editorRef])


    useEffect(() => {
    const interval = setInterval(() => {
        if (editorRef.current?.getEditor?.()) {
        // @ts-ignore
        editorRef.current.getEditor().getModule('toolbar').addHandler('image', () => {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.click();
    
            input.onchange = () => {
            const file = input.files?.[0];
            if (!file) return;
    
            const reader = new FileReader();
            reader.onload = () => {
                const img = new Image();
                img.onload = () => {
                const maxWidth = 600; // 400px
                const scale = Math.min(1, maxWidth / img.width);
                const width = img.width * scale;
                const height = img.height * scale;
    
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                if (!ctx) return;
    
                ctx.drawImage(img, 0, 0, width, height);
                const resizedBase64 = canvas.toDataURL('image/jpeg', 0.9); // can be image/png if preferred
    
                const quill = editorRef.current?.getEditor();
                if (!quill) return;
    
                setTimeout(() => {
                    const range = quill.getSelection(true) || { index: quill.getLength() };
                    try {
                    quill.insertEmbed(range.index, 'image', resizedBase64, 'user');
                    quill.setSelection(range.index + 1);
                    } catch (err) {
                    console.error('Quill insertEmbed failed:', err);
                    }
                }, 0);
                };
    
                img.src = reader.result as string;
            };
    
            reader.readAsDataURL(file);
            };
        });
    
        clearInterval(interval);
        }
    }, 100);
    
    return () => clearInterval(interval);
    }, [editorRef]);

    useEffect(() => {
        const quill = editorRef.current?.getEditor?.();
        if (!quill) return;
      
        const editorElem = quill.root;
      
        const handlePaste = (e: ClipboardEvent) => {
          const text = e.clipboardData?.getData('text/plain');
          if (text && (text.startsWith("http://") || text.startsWith("https://"))) {
            e.preventDefault();
            const range = quill.getSelection(true);
            if (range) {
              quill.insertText(range.index, text, { link: text }, 'user');
              quill.setSelection(range.index + text.length);
            }
          }
        };

      
        editorElem.addEventListener('paste', handlePaste);
      
        // Cleanup on unmount or when editor changes
        return () => {
          editorElem.removeEventListener('paste', handlePaste);
        };
    }, [editorRef.current?.getEditor?.()]);
      
    useEffect(() => {
        let cancelled = false;
        let quillInstance: any = null;
      
        const attach = () => {
          const quill = editorRef.current?.getEditor?.();
          if (!quill) {
            if (!cancelled) setTimeout(attach, 100);
            return;
          }
      /*
          const handleTextChange = () => {
            const range = quill.getSelection(true);
            if (!range || range.index < 1) return;
      
            const cursorIndex = range.index;
            const textBefore = quill.getText(0, cursorIndex);
            const words = textBefore.trim().split(/\s/);
            const lastWord = words[words.length - 1];
      
            if (/^https?:\/\/[^\s]+$/.test(lastWord)) {
              const start = cursorIndex - lastWord.length;
              setTimeout(() => {
                // @ts-expect-error
                quill.formatText({ index: start, length: lastWord.length }, { link: lastWord }, 'user');
              }, 0);
            }
          };
          */
          const handleTextChange = (delta: any, oldDelta: any, source: string) => {
            if (source !== 'user') return;
          
            const text = quill.getText();
            const regex = /https?:\/\/[^\s]+/g;
            let match: RegExpExecArray | null;
            
            while ((match = regex.exec(text)) !== null) {
              const url = match[0];
              const index = match.index;
            
              const formats = quill.getFormat(index, url.length);
              if (!formats.link) {
                setTimeout(() => {
                // @ts-expect-error
                  quill.formatText({ index, length: url.length }, { link: url }, 'user');
                }, 0);
              }
            }
          };
      
          quillInstance = quill;
          quill.on('text-change', handleTextChange);
      
          return () => {
            quill.off('text-change', handleTextChange);
          };
        };
      
        const cleanup = attach();
      
        return () => {
          cancelled = true;
          cleanup?.();
        };
      }, [editorRef]);
      
      
      


    const saveDescription = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        e.stopPropagation();

        let tempCard = {...props.card};
        tempCard.description = description;
        
        let cards = [...projectState.cards];
        let updatedCardIndex = cards.findIndex(c => c._id === tempCard._id);
        if (updatedCardIndex !== -1) {
            cards[updatedCardIndex] = tempCard;
            dispatch(setCards(cards));
        }
    
        //dispatch(saveCard(tempCard));
        let socket = openSocket(dispatch, settingsState);
        if (socket) {
            socket.emit("saveCard", { 
                card: tempCard
            });
        }  
        props.closeHandler(e, false);
    }

    let project = projectState.projects.find(p => p.loaded);

    return (
        <>
            {props.editing ?
                <>
                    <div className="descriptionBox">
                        <div className="descriptionDetails" onClick={(e) => {e.preventDefault(); e.stopPropagation(); }}> 
                            <ReactQuill theme="snow"
                                ref={editorRef}
                                value={description}
                                onChange={setDescription}
                                modules={{
                                    toolbar: {
                                      container: [...[
                                        { 'header': '1' },
                                        { 'header': '2' },
                                        "underline",
                                        "bold",
                                        "italic",
                                        "link",
                                        { 'list': 'ordered' },
                                        { 'list': 'bullet' },
                                        { 'indent': '-1' },
                                        { 'indent': '+1' }, 
                                        "image",
                                        "video",
                                        "code-block",
                                        'blockquote',
                                      ]],
                                    },
                                  }}
                            />
                        </div>
                    </div>
                    <div style={{ marginTop: "10px" }}>
                        <Link to="" onClick={(e) => saveDescription(e)} className="btn-orange">
                            Save
                        </Link>
                        <Link to="" onClick={(e) => {props.closeHandler(e, false); }}
                            className="ps-3" style={{ fontWeight: "500" }}>
                            Cancel
                        </Link>
                    </div>
                </>
            :
                <>
                {(!props.card.hasOwnProperty('description') || props.card.description === "") && description === "" && project?.permission?.toString() !== "observer" ?
                    <div onClick={(e) => {props.closeHandler(e, true)}} className="mt-2" style={{ borderRadius: "5px", backgroundColor: "#efefef" }}>
                        <div style={{ padding: "20px", fontWeight: "500", cursor: "pointer" }}>
                            Add a more detailed description...
                        </div>
                    </div>
                :
                    <>
                    {project?.permission?.toString() !== "observer" ?
                        <div onClick={(e) => e.stopPropagation()} 
                            style={{ height: "auto", paddingLeft: "0px" }}
                            className="cardDescription pt-3 ql-editor" 
                            dangerouslySetInnerHTML={{
                            __html: (description === '') ? props.card.description : description
                        }} />
                    :
                        <div className="cardDescription pt-3 ql-editor"
                            style={{ height: "auto", paddingLeft: "0px" }}
                            dangerouslySetInnerHTML={{
                            __html: (description === '') ? props.card.description : description
                        }} />
                    }
                    </>
                }
                </>
            }
        </>
    );    
}

export default CardEditor;